export const Parser = document.createElement('a');

Parser.href = '/image-statistics/';

export const URL = Parser.href;

export const getBody = data => {
    const body = new FormData();

    body.append('data', JSON.stringify(data));

    return body;
};
